function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.99077797,7 C9.44358641,7 9,6.54902482 9,6.00922203 L9,2.99791312 C9,1.89449617 9.63076481,1.63076481 10.4143185,2.4143185 L13.5856815,5.5856815 C14.366788,6.36678804 14.1017394,7 13.0020869,7 L9.99077797,7 Z M12.1205121,0.706512149 C11.7303163,0.316316264 10.9599432,0 10.4065371,0 L2,0 C0.897,0 0,0.899 0,2 L0,18 C0,19.103 0.897,20 2,20 L14,20 C15.103,20 16,19.103 16,18 L16,5.59423018 C16,5.03740003 15.6847856,4.27078565 15.2934879,3.87948785 L12.1205121,0.706512149 Z"
});

var SvgDocumentFilled = function SvgDocumentFilled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDocumentFilled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/DocumentFilled.dd4bdfe9.svg";
export { ForwardRef as ReactComponent };